



function computePerimeter(w, h, r) {
  return 2 * (w + h - 2 * r) + 2 * Math.PI * r;
}

function setupBorderRunner(el) {
  if (el.__runnerDisposer) return;

  const svgNS = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(svgNS, "svg");
  svg.classList.add("ani-border-runner-svg");
  svg.setAttribute("xmlns", svgNS);
  svg.setAttribute("fill", "none");

  const rect = document.createElementNS(svgNS, "rect");
  rect.classList.add("ani-border-runner-path");
  rect.setAttribute("x", "0.5");
  rect.setAttribute("y", "0.5");
  rect.setAttribute("pathLength", "1"); 
  svg.appendChild(rect);

  el.appendChild(svg);
  el.__runnerSvg = svg;

  const ro = new ResizeObserver(render);
  ro.observe(el);

  function render() {
    const box = el.getBoundingClientRect();
    const w = Math.max(1, Math.round(box.width));
    const h = Math.max(1, Math.round(box.height));

    
    const cs = getComputedStyle(el);
    const br = parseFloat(cs.borderTopLeftRadius) || 0;
    const r = Math.max(0, Math.min(br, Math.min(w, h) / 2));

    svg.setAttribute("viewBox", `0 0 ${w} ${h}`);
    rect.setAttribute("width", String(w - 1));
    rect.setAttribute("height", String(h - 1));
    rect.setAttribute("rx", String(r));
    rect.setAttribute("ry", String(r));

    
    const P = computePerimeter(w - 1, h - 1, r);

    
    const segPx = parseFloat(cs.getPropertyValue("--runner-length")) || 20;
    const segNorm = Math.max(0.001, Math.min(0.99, segPx / Math.max(1, P)));

    
    rect.style.strokeDasharray = `${segNorm} ${1 - segNorm}`;

    
    const thickness = parseFloat(cs.getPropertyValue("--runner-thickness")) || 2;
    rect.setAttribute("stroke-width", String(thickness));

    
  }

  render();

  el.__runnerDisposer = () => {
    ro.disconnect();
    if (svg.parentNode === el) el.removeChild(svg);
    delete el.__runnerSvg;
  };
}

export function initBorderRunner() {
  document.querySelectorAll(".ani-border-runner").forEach(setupBorderRunner);
}
